<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="page_5"></a><span class="bold">Contents</span></h2>
<h2 class="tocc"><a href="#/xhtml/Chapter01"><span class="bold"><span class="t_h">Section 1:</span></span> Shunting Locomotives</a></h2>
<h3 class="toc"><a href="#/xhtml/Chapter01#sec1-1">1.1: Pre-Nationalization Designs</a></h3>
<h3 class="toc"><a href="#/xhtml/Chapter01#sec1-2">1.2: Post-Nationalization Designs</a></h3>
<h2 class="tocc"><span href="#/xhtml/Chapter02" title="Link target outside of Sample"><span class="bold"><span class="t_h">Section 2:</span></span> Main Line Locomotives</span></h2>
<h3 class="toc"><span href="#/xhtml/Chapter02#sec2-1" title="Link target outside of Sample">2.1: Type 1 Designs</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter02#sec2-2" title="Link target outside of Sample">2.2: Type 2 Designs</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter02#sec2-3" title="Link target outside of Sample">2.3: Type 3 Designs</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter021#sec2-4" title="Link target outside of Sample">2.4: Type 4 Designs</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter021#sec2-5" title="Link target outside of Sample">2.5: Type 5 Designs</span></h3>
<h2 class="tocc"><span href="#/xhtml/Chapter03" title="Link target outside of Sample"><span class="bold"><span class="t_h">Section 3:</span></span> Heritage Centres</span></h2>
<h3 class="toc"><span href="#/xhtml/Chapter03#sec3-1" title="Link target outside of Sample">3.1: Barrow Hill Roundhouse (BHR)</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter03#sec3-2" title="Link target outside of Sample">3.2: Bo’ness &amp; Kinneil Railway (BKR)</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter03#sec3-3" title="Link target outside of Sample">3.3: Embsay &amp; Bolton Abbey Railway (EBAR)</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter03#sec3-4" title="Link target outside of Sample">3.4: East Lancashire Railway (ELR)</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter03#sec3-5" title="Link target outside of Sample">3.5: Great Central Railway (GCR)</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter03#sec3-6" title="Link target outside of Sample">3.6: Keighley &amp; Worth Valley Railway (KWVR)</span></h3>
<h3 class="toc"><span href="#/xhtml/Chapter03#sec3-7" title="Link target outside of Sample">3.7: Severn Valley Railway (SVR)</span></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?d5dce556